import { Dropdown } from "components/Dropdown";

import { TRANSIENT_INPUT_HEIGHT } from "../lib/transientForm";
import { ScenarioFieldRow } from "./ScenarioFieldRow";

type TransientMultiSelectFieldRowProps = {
  alignControlEnd?: boolean;
  displayOptions: string[];
  label: string;
  labelClassName?: string;
  onChange: (values: string[]) => void;
  options: readonly string[];
  selectedValues: string[];
};

export const TransientMultiSelectFieldRow = ({
  alignControlEnd = false,
  displayOptions,
  label,
  labelClassName,
  onChange,
  options,
  selectedValues,
}: TransientMultiSelectFieldRowProps) => {
  return (
    <ScenarioFieldRow alignControlEnd={alignControlEnd} label={label} labelClassName={labelClassName}>
      {/* @ts-expect-error Dropdown is a JS component with incomplete prop typings. */}
      <Dropdown
        className="w-full"
        displayOptions={displayOptions}
        height={TRANSIENT_INPUT_HEIGHT}
        label=" "
        options={[...options]}
        setValues={(values: Array<number | string>) => onChange(values.map(String))}
        values={selectedValues}
      />
    </ScenarioFieldRow>
  );
};
